import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, goToLogin } from "@/contexts/AuthContext";
import oiiisterLogo from "@/assets/oiiister-logo.png";

export default function LoginPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [params] = useSearchParams();

  useEffect(() => {
    if (!loading && user) navigate("/", { replace: true });
  }, [user, loading, navigate]);

  useEffect(() => {
    if (params.get("error")) {
      toast.error("Sign-in was cancelled or failed. Try again.");
    }
  }, [params]);

  return (
    <div className="max-w-md mx-auto px-6 pt-24 pb-16">
      <div className="bg-white rounded-3xl ring-1 ring-[#F3F4F6] p-10">
        <img src={oiiisterLogo} alt="Oiiister" className="w-12 h-12 rounded-2xl" />
        <h1 className="mt-6 font-display font-bold text-3xl leading-tight text-[#111827]">
          Welcome to Oiiister.
        </h1>
        <p className="mt-3 text-[#4B5563] leading-relaxed">
          Sign in to post AI problems, add your own solutions, and get in touch
          with people who've solved yours.
        </p>

        <button
          onClick={() => goToLogin("/")}
          data-testid="google-signin"
          className="mt-8 w-full h-12 rounded-full bg-[#111827] hover:bg-black text-white font-semibold flex items-center justify-center gap-3 transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden>
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.3-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3 0 5.7 1.1 7.8 3l5.7-5.7C34 6.1 29.3 4 24 4c-7.7 0-14.4 4.4-17.7 10.7z"/>
            <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.5-5.2l-6.2-5.2c-2 1.4-4.5 2.4-7.3 2.4-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.5 39.6 16.2 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4-4.1 5.2l6.2 5.2c-.4.4 6.6-4.8 6.6-14.4 0-1.2-.1-2.3-.4-3.5z"/>
          </svg>
          Continue with Google
        </button>

        <p className="mt-5 text-xs text-[#9CA3AF] leading-relaxed">
          We only ask Google for your name, email, and photo. No posts on your
          behalf, ever.
        </p>
      </div>

      <p className="mt-6 text-sm text-[#4B5563] text-center">
        Just browsing?{" "}
        <button
          onClick={() => navigate("/")}
          className="text-[#3FFFB6] hover:text-[#2DE59F] font-medium"
        >
          Explore the directory →
        </button>
      </p>
    </div>
  );
}
